import { NavMenu } from './NavMenu';
import { Props } from './propts';

export type MatNavProps = Props;

export * from './NavMenu';

export default NavMenu;
